import { Model } from 'modules/core/lib/mobx-rest'

interface ICopyScheduleStats {}

class CopyScheduleStats extends Model<ICopyScheduleStats> {
  static urlRoot() {
    return '/shift_management/copy_schedule_stats'
  }
}

export default CopyScheduleStats
